import events from "./events";
import methods from "./methods";

const exports = {
  events,
  methods,
};

export default exports;
